// Consent state as far as this app is concerned.
//
// UNKNOWN     - the CMP has not answered yet. Treat exactly like a refusal:
//               nothing may load, but the UI can still say "loading".
// READY       - the CMP answered; `services` reflects the visitor's choice.
// UNAVAILABLE - the CMP will not answer (blocked by an extension, offline,
//               script error). Nothing may load and there is no point showing
//               a button that opens a consent dialog which does not exist.
export const CONSENT_STATUS = {
  UNKNOWN: 'unknown',
  READY: 'ready',
  UNAVAILABLE: 'unavailable',
};

// Usercentrics template IDs. Names are localised and change when someone edits
// the panel; IDs are stable, so gate on these.
//
// Verified against the draft configuration 76.21.192 (2026-10-07). The
// declaration was reduced from 43 services to 22 on 2026-09-23 and the missing
// ones were added. The draft is not published yet - production still serves
// 43.8.176, which knows neither Pipedrive nor Sentry - but template IDs do not
// change on publish.
export const CONSENT_SERVICES = {
  USERCENTRICS: 'H1Vl5NidjWX',
  GOOGLE_TAG_MANAGER: 'BJ59EidsWQ',
  GOOGLE_ANALYTICS: 'HkocEodjb7',
  GOOGLE_ADS: 'S1_9Vsuj-Q',
  FACEBOOK_PIXEL: 'ko1w5PpFl',
  LINKEDIN_INSIGHT: 'JQ2XQxIk',
  HOTJAR: 'S1kgcNo_j-m',
  MICROSOFT_CLARITY: '-5ZUD1WwiZjOOn',
  YOUTUBE: 'BJz7qNsdj-7',
  CLOUDINARY: 'r1HocEjOiWm',
  GOOGLE_FONTS: 'HkPBYFofN',
  GOOGLE_AJAX: 'H1PKqNodoWQ',
  WEBFLOW_CDN: 'BJ_ocNjds-X',
  JQUERY: 'Sy7BcNo_ib7',
  PIPEDRIVE: 'OOQl7TEfwRceQ1',
  LIVESTORM: 'w9w-VfSnMOg1_Z',
  SENTRY: 'rH1vNPCFR',
  SLIDESHARE: 'jhJqRRPUe',
};

// Category slugs. The opaque ones are custom categories created on 2026-09-23:
// the stock `functional` category was labelled "Performance" and held both web
// fonts and session recording, which no visitor could tell apart - so analytics
// was split out into its own category and `functional` was replaced. Slugs of
// custom categories are generated by Usercentrics and carry no meaning; the
// label is what the banner shows.
//
// Gate on services rather than categories wherever possible: a category verdict
// is an AND across everything in it, so one refused service hides the rest.
export const CONSENT_CATEGORIES = {
  ESSENTIAL: 'essential',
  FUNCTIONAL: 'customCategory-7989ac87-0356-41ba-b05e-8ffca1f55192',
  ANALYTICS: 'customCategory-014ff7af-294d-4953-a0c5-380cc4b0c5df',
  MARKETING: 'marketing',
};

// Every consumer of the store must survive getting this object: it is what SSR
// renders against, what the first client render sees, and what a visitor with
// the CMP blocked keeps seeing. Frozen so a caller cannot mutate shared state,
// and shared by reference so useSyncExternalStore does not loop.
export const DENIED_SNAPSHOT = Object.freeze({
  status: CONSENT_STATUS.UNKNOWN,
  services: Object.freeze({}),
  categories: Object.freeze({}),
});

// How long to wait for the CMP before declaring it unavailable. The loader is
// async and competes with the Gatsby bundle, so this has to tolerate a slow
// connection; it only gates the wording of the placeholder, never what loads.
export const CMP_TIMEOUT_MS = 8000;

export const CMP_POLL_INTERVAL_MS = 300;
